//Import required libraies
import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//Import Custom Component
import HeaderAdmin from "../../components/HeaderAdmin/HeaderAdmin";
import Footer from "../../components/Footer/Footer";
import SidenavAdmin from "../../components/SidenavAdmin/SidenavAdmin";
import Loader from "../../components/Loader/Loader";
import HeaderBucket from "../../components/HeaderBucket/HeaderBucket";
import SidenavBucket from "../../components/SidenavBucket/SidenavBucket";

//Import Custom Hooks

//Import utils/data

//Import styles

function LayoutTopSideBottomBucket(props) {
  // * Destructure props
  const {
    user,
    children,
    handleActiveTab = () => {},
    activeTab,
    isSidenavVisible = true,
  } = props;

  // * Define required static variables for props
  const sidenavAdminProps = {
    handleActiveTab,
  };
  var sectionClass = "content";
  if (!isSidenavVisible) sectionClass += " without-sidenav";

  return (
    <div className={`page layout-top-side-bottom`}>
      {user.screen.isDashboardLoading && (
        <section className={`dashboard-loader-container`}>
          <Loader />
        </section>
      )}
      <HeaderBucket />
      <main>
        {isSidenavVisible && (
          <section className={`sidenav`}>
            <SidenavBucket {...sidenavAdminProps} />
          </section>
        )}
        <section className={sectionClass}>
          <section className={`main-content-data`}>{children}</section>
        </section>
      </main>

      <Footer />
    </div>
  );
}

LayoutTopSideBottomBucket.propTypes = {
  children: PropTypes.node,
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({ user: state.user });

export default connect(mapStateToProps)(LayoutTopSideBottomBucket);
